import api from '../token';

export const DeleteFPagamento = async (dados) => {
  try {
    const response = await api.post('/deleteFPagamento', dados);
    return response.data;
  } catch (error) {
   
    return [];
  }
};

